import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const StarEmptyIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  const aspectRatio = 17 / 16;
  const width = Number(size) * aspectRatio;
  return __jsx("svg", _extends({
    width: width,
    height: size,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M2.92707 14.8508C2.84927 15.2942 3.28683 15.6413 3.67327 15.4427L8.0625 13.1868L12.4517 15.4427C12.8382 15.6413 13.2757 15.2942 13.1979 14.8508L12.3682 10.1213L15.8905 6.76462C16.2197 6.45092 16.0493 5.87737 15.6083 5.81472L10.7099 5.11885L8.52573 0.792305C8.32898 0.402565 7.79602 0.402565 7.59927 0.792305L5.41515 5.11885L0.516672 5.81472C0.0756827 5.87737 -0.0947175 6.45092 0.234463 6.76462L3.75679 10.1213L2.92707 14.8508ZM7.83167 12.0826L4.14592 13.977L4.84017 10.0197C4.8729 9.83316 4.81136 9.64214 4.67743 9.5145L1.77059 6.7444L5.82289 6.16873C5.99041 6.14494 6.13668 6.03795 6.2157 5.88141L8.0625 2.22308L9.9093 5.88141C9.98832 6.03795 10.1346 6.14494 10.3021 6.16873L14.3544 6.7444L11.4476 9.5145C11.3136 9.64214 11.2521 9.83316 11.2848 10.0197L11.9791 13.977L8.29333 12.0826C8.14773 12.0078 7.97726 12.0078 7.83167 12.0826Z",
    fill: color
  }));
};
export default StarEmptyIcon;